module.exports = __webpack_public_path__ + "static/img/varieties.02039c5c.svg";